// extracted by mini-css-extract-plugin
export default {"container":"Container_container__VVOCq","small":"Container_small__EkeKL","medium":"Container_medium__+VPRG","large":"Container_large__s+TD0"};